<template>
  <div class="sticky-sidebar">
    <!-- Uçuş Detay Kartları -->
    <template v-for="(booking, bi) in ticketAllocate">
      <div v-for="(legSegs, li) in getLegs(booking.FlightSegments)" :key="'leg-' + bi + '-' + li"
        class="flight-card section-card">
        <!-- Leg Başlığı -->
        <div class="flight-leg-head">
          <div style="display:flex;align-items:center;gap:8px;">
            <v-img :src="getImgUrl(legSegs[0].OperatingAirline)" height="28px" width="72px" contain></v-img>
          </div>
          <div style="display:flex;align-items:center;gap:6px;">
            <span v-if="legSegs.length > 1" class="badge-transfer">
              {{ legSegs.length - 1 }} Aktarma
            </span>
            <span v-if="li === 0 && getLegs(booking.FlightSegments).length > 1"
              class="badge-direction">Gidiş</span>
            <span v-if="li === 1" class="badge-direction return">Dönüş</span>
          </div>
        </div>
        <!-- Rota -->
        <div class="flight-route-row">
          <div class="flight-ep">
            <div class="flight-time">{{ legSegs[0].DepartureTime }}</div>
            <div class="flight-iata">{{ legSegs[0].DepartureAirportCode }}</div>
            <div class="flight-date-label">{{ legSegs[0].DepartureDate | dateSlice }}</div>
          </div>
          <div class="flight-mid">
            <div class="dashed-line-left"></div>
            <v-icon color="#9ca3af" style="transform:rotate(90deg);" size="20">flight</v-icon>
            <div class="dashed-line-right"></div>
          </div>
          <div class="flight-ep text-right">
            <div class="flight-time">{{ legSegs[legSegs.length - 1].ArrivalTime }}</div>
            <div class="flight-iata">{{ legSegs[legSegs.length - 1].ArrivalAirportCode }}</div>
            <div class="flight-date-label">{{ legSegs[legSegs.length - 1].ArrivalDate | dateSlice }}</div>
          </div>
        </div>
        <!-- Aktarma Noktaları -->
        <div v-if="legSegs.length > 1">
          <v-divider style="border-color:#fed7aa;margin:0;"></v-divider>
          <div v-for="(seg, si) in legSegs.slice(0, legSegs.length - 1)" :key="'tr-' + si"
            class="transfer-stop">
            <v-icon color="#d97706" small>sync_alt</v-icon>
            <span style="font-size:12px;color:#92400e;">
              {{ seg.ArrivalAirportName }} ({{ seg.ArrivalAirportCode }}) aktarma
            </span>
          </div>
        </div>
      </div>
    </template>

    <!-- Kural Chip'leri -->
    <div v-if="ticketAllocateReady" style="margin-bottom:12px;display:flex;flex-wrap:wrap;gap:6px;">
      <v-chip v-if="ticketAllocate[0].FlightSegments[0].FareCode === 'Promo'" outline color="primary" small>
        <v-icon left color="primary" small>local_offer</v-icon>
        {{ ticketAllocate[0].Provider }} Promosyon
      </v-chip>
      <v-chip v-else outline color="primary" small>
        <v-icon left color="primary" small>flight</v-icon>
        {{ ticketAllocate[0].Provider }} Esnek
      </v-chip>
    </div>

    <!-- Fiyat Özeti Kartı -->
    <div class="section-card price-summary-card" v-if="ticketAllocate.length > 0">
      <div style="padding:14px 18px;border-bottom:1px solid #f3f4f6;">
        <span style="font-size:14px;font-weight:600;color:#1f2937;">{{ $t('Fiyat-Özeti') }}</span>
      </div>
      <div v-for="(ticket, ti) in ticketAllocate" :key="'tkt-' + ti">
        <!-- PDF butonu (bilet kesilmişse) -->
        <div v-if="IsBooking"
          style="display:flex;justify-content:space-between;align-items:center;padding:8px 18px;background:#f9fafb;">
          <span style="font-size:12px;font-weight:600;color:#374151;">
            📋 {{ formatTicketNumber(ticket) }}
          </span>
          <v-btn @click="$emit('downloadPdf', ticket)">
            {{ $t('Download-PDF') }}
          </v-btn>
        </div>
        <!-- Yolcu Kalemleri -->
        <div v-for="(pax, pi) in ticket.PassengerBreakdowns" :key="'pb-' + ti + '-' + pi"
          class="pax-price-row">
          <div :class="['pax-type-chip', paxChipClass(pax.PaxReference.PaxCode)]">
            {{ pi + 1 }}. {{ pax.PaxReference.PaxCode | passengerType }}
          </div>
          <div class="price-line-item">
            <span class="price-item-label">{{ $t('Base-Fare') }}</span>
            <span>{{ resolveBaseFare(pax) | moneyformat }} {{ searchCurrency }}</span>
          </div>
          <div class="price-line-item">
            <span class="price-item-label">{{ $t('Tax') }}</span>
            <span>{{ resolveTotalTax(pax) | moneyformat }} {{ searchCurrency }}</span>
          </div>
          <div class="price-line-item" v-if="toNumber(resolveTotalServiceFee(pax)) > 0">
            <span class="price-item-label">{{ $t('Supplier-Service-Fee') }}</span>
            <span>{{ resolveTotalServiceFee(pax) | moneyformat }} {{ searchCurrency }}</span>
          </div>
          <div class="price-line-item" v-if="toNumber(resolveTotalMarkupFare(pax)) > 0">
            <span class="price-item-label">{{ $t('Markup') }}</span>
            <span>{{ resolveTotalMarkupFare(pax) | moneyformat }} {{ searchCurrency }}</span>
          </div>
          <div class="price-line-item pax-subtotal">
            <span>{{ $t('subtotal') }}</span>
            <span>{{ resolveTotalFare(pax) | moneyformat }} {{ searchCurrency }}</span>
          </div>
        </div>
      </div>
      <!-- Genel Toplam -->
      <div class="grand-total-box">
        <div style="display:flex;justify-content:space-between;align-items:flex-end;">
          <span style="font-size:13px;color:#6b7280;">{{ $t('totalamount') }}</span>
          <div style="text-align:right;">
            <div style="font-size:28px;font-weight:700;color:#667eea;line-height:1.1;">
              {{ footerTotalFare | moneyformat }}
            <span style="font-size:10px;color:#9ca3af;line-height:1;">{{ searchCurrency }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Aksiyon Butonları Kartı -->
    <div class="section-card action-card" v-if="ticketAllocateReady">
      <!-- Yeni Bilet Modu -->
      <template v-if="!isUpdate">
        <v-btn block :disabled="loadingvmodel" @click="$emit('updatePassenger', 1)" class="action-btn"
          style="background:linear-gradient(135deg,#667eea,#764ba2);color:#fff;">
          <v-icon left>book_online</v-icon>{{ $t('Make-a-Reservation') }}
        </v-btn>
        <v-btn block :disabled="loadingvmodel" @click="$emit('updatePassenger', 2)" class="action-btn"
          style="background:#10b981;color:#fff;">
          <v-icon left>account_balance_wallet</v-icon>{{ $t('Hotel-Pay-From-Current') }}
        </v-btn>
        <v-btn v-if="Provider === 'Turna' || Provider === 'BiletBank' || Provider === 'Amadeus'" block
          :disabled="loadingvmodel" @click="$emit('updatePassengerCard', 3, 'update')" class="action-btn"
          style="background:#3b82f6;color:#fff;">
          <v-icon left>credit_card</v-icon>{{ $t('Hotel-Pay-By-Card') }}
        </v-btn>
      </template>

      <!-- Mevcut Rezervasyon Modu (bilet kesilmemiş) -->
      <template v-if="isUpdate && !IsBooking">
        <v-btn block :disabled="loadingvmodel || !IsCancelable" @click="$emit('cancelReservation')"
          class="action-btn" style="background:#fff;border:2px solid #ef4444;color:#ef4444;">
          <v-icon left>cancel</v-icon>{{ $t('Cancel-Reservation-v2') }}
        </v-btn>
        <v-btn block :disabled="loadingvmodel" @click="$emit('startPaymentWithPrebook', 2)" class="action-btn"
          style="background:#10b981;color:#fff;">
          <v-icon left>account_balance_wallet</v-icon>{{ $t('Hotel-Pay-From-Current') }}
        </v-btn>
        <v-btn v-if="Provider === 'Turna' || Provider === 'BiletBank' || Provider === 'Amadeus'" block
          :disabled="loadingvmodel" @click="$emit('updatePassengerCard', 3, 'payment')" class="action-btn"
          style="background:#3b82f6;color:#fff;">
          <v-icon left>credit_card</v-icon>{{ $t('Hotel-Pay-By-Card') }}
        </v-btn>
      </template>

      <!-- Bilet Kesilmiş Modu -->
      <template v-if="isUpdate && IsBooking">
        <v-btn v-if="!nextStatu" block :disabled="loadingvmodel" @click="$emit('sendNextTicket', ShoppingCard)"
          class="action-btn" style="background:#8b5cf6;color:#fff;">
          <v-icon left>edit</v-icon>Arkmana İşle
        </v-btn>
        <v-btn v-if="nextStatu" block :disabled="loadingvmodel" @click="$emit('goNextTicket', ShoppingCard)"
          class="action-btn" style="background:#8b5cf6;color:#fff;">
          <v-icon left>search</v-icon>Arkmanda Göster
        </v-btn>
      </template>

      <v-btn block flat @click="$router.go(-1)" class="action-btn"
        style="background:#f3f4f6;color:#4b5563;">
        <v-icon left>arrow_back</v-icon>Geri Dön
      </v-btn>
    </div>
  </div>
</template>

<script>
import logoo from "@/assets/control.js";
import Airports from "@/components/app/satis/ucak/airports.js";
import helpers from "@/components/app/customcomp/helpers.js";
import { resolvePriceField } from "@/components/app/satis/comp/ucak/comp/fareCurrency";

export default {
  name: "FlightSidebar",
  props: {
    ticketAllocate: { type: Array, required: true },
    ticketAllocateReady: { type: Boolean, required: true },
    IsBooking: { type: Boolean, default: false },
    isUpdate: { type: Boolean, default: false },
    loadingvmodel: { type: Boolean, default: false },
    IsCancelable: { type: Boolean, default: false },
    nextStatu: { type: Boolean, default: false },
    Provider: { type: String, default: "" },
    ShoppingCard: { type: Object, default: null },
    footerTotalFare: { type: Number, default: 0 },
    searchCurrency: { type: String, default: 'TRY' },
  },
  methods: {
    getLegs(segments) {
      if (!segments || !segments.length) return [];
      if (segments.length === 1) return [segments];
      const firstDep = segments[0].DepartureAirportCode;
      const lastArr = segments[segments.length - 1].ArrivalAirportCode;
      if (firstDep === lastArr) {
        const mid = Math.ceil(segments.length / 2);
        return [segments.slice(0, mid), segments.slice(mid)];
      }
      return [segments];
    },
    getImgUrl(img) {
      return logoo.logoControl(img);
    },
    formatTicketNumber(ticket) {
      if (!ticket || !ticket.PassengerBreakdowns || !ticket.PassengerBreakdowns.length) return "";
      const n = ticket.PassengerBreakdowns[0].TicketNumber;
      if (!n || n.length <= 3) return n || "";
      return n.substring(0, 3) + "-" + n.substring(3);
    },
    paxChipClass(paxCode) {
      if (paxCode === "ADT") return "chip-adult";
      if (paxCode === "CHD") return "chip-child";
      return "chip-infant";
    },
    toNumber(val) {
      if (val == null) return 0;
      return parseFloat(val.toString().replace(/,/g, "")) || 0;
    },
    resolveBaseFare(pax) {
      return resolvePriceField(pax, 'BaseFare', this.searchCurrency);
    },
    resolveTotalTax(pax) {
      return resolvePriceField(pax, 'TotalTax', this.searchCurrency);
    },
    resolveTotalServiceFee(pax) {
      return resolvePriceField(pax, 'TotalServiceFee', this.searchCurrency);
    },
    resolveTotalMarkupFare(pax) {
      return resolvePriceField(pax, 'TotalMarkupFare', this.searchCurrency);
    },
    resolveTotalFare(pax) {
      return resolvePriceField(pax, 'TotalFare', this.searchCurrency);
    }
  },
  filters: {
    passengerType(val) { return Airports.passengerType(val); },
    moneyformat(m) { return helpers.moneyformat(m); },
    dateSlice(val) { return val ? val.substring(0, 10) : ""; },
  }
};
</script>

<style scoped>
/* Include necessary styles here from islem.vue */
.sticky-sidebar { position: sticky; top: 16px; }
.section-card { background: #fff; border-radius: 16px; box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08); margin-bottom: 14px; overflow: hidden; }
.flight-card.section-card { border-radius: 12px; padding: 0; }
.flight-leg-head { display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; border-bottom: 1px solid #f3f4f6; }
.badge-transfer { background: #fef3c7; color: #d97706; font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 12px; }
.badge-direction { background: #ede9fe; color: #667eea; font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 12px; }
.badge-direction.return { background: #d1fae5; color: #059669; }
.flight-route-row { display: flex; align-items: center; padding: 14px; gap: 8px; }
.flight-ep { flex: 1; }
.flight-ep.text-right { text-align: right; }
.flight-time { font-size: 22px; font-weight: 700; color: #1f2937; line-height: 1.1; }
.flight-iata { font-size: 14px; color: #6b7280; font-weight: 500; }
.flight-date-label { font-size: 11px; color: #9ca3af; }
.flight-mid { display: flex; align-items: center; flex: 0 0 auto; gap: 4px; }
.dashed-line-left, .dashed-line-right { width: 28px; border-top: 2px dashed #d1d5db; }
.transfer-stop { display: flex; align-items: center; gap: 6px; padding: 6px 14px; background: #fffbeb; }
.pax-price-row { padding: 10px 18px; border-bottom: 1px solid #f9fafb; }
.pax-price-row:hover { background: #f9fafb; }
.pax-type-chip { display: inline-block; font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 10px; margin-bottom: 6px; }
.chip-adult { background: #dbeafe; color: #1d4ed8; }
.chip-child { background: #d1fae5; color: #065f46; }
.chip-infant { background: #fed7aa; color: #92400e; }
.price-line-item { display: flex; justify-content: space-between; font-size: 12px; color: #6b7280; padding: 1px 0; }
.price-item-label { color: #9ca3af; }
.pax-subtotal { margin-top: 4px; font-weight: 600; color: #374151; font-size: 12px; }
.grand-total-box { padding: 16px 18px; border-top: 2px solid #f3f4f6; background: #fafafa; }
.action-card { padding: 14px; }
.action-btn { border-radius: 10px !important; height: 46px !important; font-weight: 600 !important; text-transform: none !important; margin-bottom: 8px !important; box-shadow: none !important; font-size: 14px !important; }
</style>